import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalController, Platform, PopoverController } from '@ionic/angular';
import { EditArt } from '../../../_interfaces/EditArt';
import { HttpFunctionResult } from '../../../_interfaces/HttpFunctionResult';
import { FeedbackService } from '../../../_provider/feedback.service';
import { TicketEmployee } from '../../../_provider/tickets/ticket.service';
import { DarkmodeService } from '../../../_provider/darkmode.service';
import { PopoverListItem, PopoverPage } from '../../popover/popover.page';
import { ContentEditPopupPage } from '../content-edit-popup/content-edit-popup.page';
import { ZeitenService } from '../../../_provider/zeiten.service';
import { TicketZeit } from '../../../_interfaces/TicketTime';
import { UserInformationPopover } from 'src/app/_provider/userselect.service';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { HeaderComponent } from '../../header/header.component';
import { UserInformationComponent } from './user-information/user-information.component';
import { AuthService, ROLE } from 'src/app/_provider/auth.service';
import { TicketServiceBase } from 'src/app/_provider/tickets/ticketBase.service';
import { TicketCustomer } from 'src/app/_provider/tickets/ticketCustumer.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { WorkstepReadStatePopoverComponent } from './workstep-read-state-popover/workstep-read-state-popover.component';



export interface WorkstepContent{
  id: number,
  htmlText: string,
  userText?: string
  plainText?: string
  ticketId?: number
  workstepId?: number
  isMail?: boolean
  mailDescription?: string
  isNew?: boolean
  art?: EditArt
  from?: EditArt
  taskId?: number
  date?: Date
  readByAll?: boolean
}

@Component({
  selector: 'app-workstep-content',
  templateUrl: './workstep-content.component.html',
  styleUrls: ['./workstep-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WorkstepContentComponent implements OnInit {

  @Input() content: WorkstepContent
  @Input() isLoading: boolean
  @Input() hightlight: boolean = false
  @Input() withLine: boolean = true
  @Input() contentOnEditID: number
  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>()
  @Output() onEdit: EventEmitter<WorkstepContent> = new EventEmitter<WorkstepContent>()
  @Output() mailByContent: EventEmitter<number> = new EventEmitter<number>()

  public htmlContent: string = ""

  public contentHeight: number = 60
  public isOpen: boolean = true

  public employeeInformationPosition: UserInformationPopover = {active: false}
  public customLightmode: boolean = false

  public showEditHeader: boolean = this.authSrv.role == ROLE.employee

  @ViewChild("htmlContent", {static: false}) nativeHTMLContent: ElementRef
  @ViewChild("userInformation", {static: false}) userInformation: UserInformationComponent

  private ticketSrv: TicketServiceBase

  constructor(
    private ticketSrvEmployee: TicketEmployee.TicketService,
    private ticketSrvCustomer: TicketCustomer.TicketService,
    public darkmode: DarkmodeService,
    private editSrv: TicketEditService,
    private feedback: FeedbackService,
    private general: GeneralService,
    private timeSrv: ZeitenService,
    private changeDetector: ChangeDetectorRef,
    public authSrv: AuthService
  ) { 
    if(this.authSrv.role == ROLE.employee) this.ticketSrv = ticketSrvEmployee
    else this.ticketSrv = ticketSrvCustomer
  }

  ngOnInit() {
    setTimeout(() => {

      this.nativeHTMLContent?.nativeElement?.querySelectorAll(".userselected").forEach(element=>{
        element.addEventListener("mouseenter", async(e)=>{
          let pos = element.getBoundingClientRect()  
          
          let editorPos = this.nativeHTMLContent?.nativeElement?.getBoundingClientRect()
          this.employeeInformationPosition = {
              active: true,
              employee: this.editSrv.employees.find(e => e.id == +element.classList.value.split(" ").find(c => c.includes("userid-")).replace("userid-", "")),
              animation: e.fromElement.classList.contains("distance") ? false : true,
              y: (pos.bottom - editorPos.bottom) * -1 + 20 + (this.contentHeight < 60 ? 20 : 30),
              x: (pos.left - editorPos.left) + 20
            }

        })
        element.addEventListener("mouseleave", ()=>{
          this.employeeInformationPosition.active = false
          this.employeeInformationPosition.animation = false
        })
      })

      this.userInformation.element.nativeElement.addEventListener("mouseenter", ()=>{
        this.employeeInformationPosition.active = true
        this.employeeInformationPosition.animation = false
      })
      this.userInformation.element.nativeElement.addEventListener("mouseleave", ()=>this.employeeInformationPosition.active = false)

    }, 300);
  }

  ngAfterViewChecked(){
    this.contentHeight = this.nativeHTMLContent?.nativeElement?.scrollHeight;
    this.changeDetector.detectChanges()
  }

  public async openEditOptions(event: any){

    let list: PopoverListItem[] = [
      {id: 1, description: "Bearbeiten", icon: "fa-pen"},
      {id: 4, description: "Theme ändern", icon: "fa-darkmode"},
      {id: 2, description: "Löschen", icon: "fa-trash", danger: true}
    ]

    if(this.authSrv.includesRole("employee") && this.general.serverVersionGreaterThan("1.8.0") && this.general.webConfig.hasDesktopPfad) list.unshift({id: 3, description: "E-Mail erstellen", icon: "fa-mail-unread"})

    await this.feedback.openPopover<EditArt>(PopoverPage, event, {list: list}, async (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      if(result.data.id == 1){
        //Zeit starten für aktuellen Arbeitsschritt wenn noch keine gestartet ist
        if(this.timeSrv.isActiveTicket(this.ticketSrv.activeWorkstepId) == null && this.authSrv.role == ROLE.employee){
          await this.feedback.updateLoading("Zeit starten...")
          await this.timeSrv.startTicketTime(this.ticketSrv.activeWorkstepId, this.ticketSrv.ticket)
          await this.feedback.hideLoading()
          this.feedback.showInformationToast("Die Zeit für den ausgewählten Arbeitsschritt wurde gestartet.", "Zeit gestartet", 3000)
        }
        
        await this.edit()
      }
      else if(result.data.id == 2) await this.delete()
      else if(result.data.id == 3) this.mailByContent.emit(this.content.id)
      else if(result.data.id == 4) this.customLightmode = !this.customLightmode

    })

  }

  public async edit(){
    if(this.content.isMail)
      if(!(await this.feedback.confirm("Diese Nachricht stammt aus einer E-Mail. Sicher dass Sie diese bearbeiten möchten?", "Bearbeiten", "Abbrechen"))) return
    if(this)
      this.onEdit.next(this.content)
  }

  private async delete(){
    if(!(await this.feedback.confirm("Möchten Sie den Eintrag wirklich löschen?", "Löschen", "Abbrechen"))) return
    await this.feedback.updateLoading("Löschen...")
    await this.ticketSrv.deleteWorkstepContent(this.content)
    await this.feedback.hideLoading()
    this.onDelete.emit()
  }

  public editClosed(){
    this.onEdit.next(null)
  }

  public async openReadState($event){
    await this.feedback.showPopover({
      event: $event,
      componentProps: { contentId: this.content.id },
      component: WorkstepReadStatePopoverComponent,
    })
  }

}
